export const LOAD_AUTH_INFO = 'load-auth-info';
export const LOG_OUT = 'log-out';



// WEBPACK FOOTER //
// ./web/action/auth_types.jsx